<template>
  <tabs
    :tab-name="['Enquiries', 'Bookings', 'Personal', 'Notes', 'Attachments']"
    :tab-icon="[
      'perm_phone_msg',
      'event_available',
      'flight',
      'text_snippet',
      'attach_file'
    ]"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <customer-tabs-enquiries :customer="customer" />
    </template>

    <template slot="tab-pane-2">
      <customer-tabs-booking :customer="customer" />
      <customer-tabs-historic-booking :customer="customer" />
    </template>

    <template slot="tab-pane-3">
      <customer-tabs-travel :customer="customer" />
    </template>

    <template slot="tab-pane-4">
      <customer-tabs-notes :customer="customer" />
    </template>

    <template slot="tab-pane-5">
      <customer-tabs-attachments :customer="customer" />
    </template>
  </tabs>
</template>
<script>
import { Tabs } from "@/components";
import CustomerTabsBooking from "./CustomerTabsBooking";
import CustomerTabsHistoricBooking from "./CustomerTabsHistoricBooking";
import CustomerTabsEnquiries from "./CustomerTabsEnquiries";
import CustomerTabsTravel from "./CustomerTabsTravel";
import CustomerTabsNotes from "./CustomerTabsNotes";
import CustomerTabsAttachments from "./CustomerTabsAttachments";

export default {
  props: ["customer"],

  components: {
    Tabs,
    CustomerTabsBooking,
    CustomerTabsHistoricBooking,
    CustomerTabsEnquiries,
    CustomerTabsTravel,
    CustomerTabsNotes,
    CustomerTabsAttachments
  }
};
</script>

<style scoped>
.md-card-tabs.md-card-plain .md-list {
  justify-content: start;
}
</style>
